export var officialType;
(function (officialType) {
    officialType[officialType["UNAUTHED"] = 0] = "UNAUTHED";
    officialType[officialType["ENTERPRISE"] = 1] = "ENTERPRISE";
    officialType[officialType["ENTERPRISE_MEDIA"] = 2] = "ENTERPRISE_MEDIA";
    officialType[officialType["GOVERNMENT"] = 3] = "GOVERNMENT";
    officialType[officialType["NON_PROFIT_ORGANIZATION"] = 4] = "NON_PROFIT_ORGANIZATION";
    officialType[officialType["PRIVATE_NON_ENTERPRISE"] = 5] = "PRIVATE_NON_ENTERPRISE";
    officialType[officialType["FOR_PROFIT_ORGANIZATION"] = 6] = "FOR_PROFIT_ORGANIZATION";
    officialType[officialType["SOCIAL_GROUPS"] = 8] = "SOCIAL_GROUPS";
    officialType[officialType["BUSINESS_MEDIA"] = 9] = "BUSINESS_MEDIA";
    officialType[officialType["BUSINESS_UNIT"] = 11] = "BUSINESS_UNIT";
    officialType[officialType["INDIVIDUAL_INDUSTRIAL_AND_COMMERCIAL_HOUSEHOLDS"] = 12] = "INDIVIDUAL_INDUSTRIAL_AND_COMMERCIAL_HOUSEHOLDS";
    officialType[officialType["OVERSEAS_COMPANIES"] = 13] = "OVERSEAS_COMPANIES";
})(officialType || (officialType = {}));
